import { put, takeEvery } from 'redux-saga/effects';

import * as actionTypes from '../../modules/casino/store/actions/actionTypes';
import ClientAPI from '../../modules/casino/ClientAPI/ClientAPI';
import * as paths from '../../modules/casino/ClientAPI/paths';
import { receivedCurrencies } from '../slices/currencies';

function* requestCurrenciesSaga(): any {
  const axios = ClientAPI.getInstance();

  try {
    const response = yield axios({
      url: paths.profile.GET_CURRENCIES,
      method: 'post',
      data: {
        currencies: window.config.currencies,
      },
    });

    if (!response || typeof response.result === 'undefined') {
      return;
    }

    yield put(receivedCurrencies(response.result));
  } catch (error) {
    console.log('requestCurrenciesSaga', error);
  }
}

export default function* watchCurrenciesSaga() {
  yield takeEvery(actionTypes.wallet.REQUEST_WALLET, requestCurrenciesSaga);
}